import {
    CommandCenterHousehold,
    GlobalAccountRoleType,
    HouseholdType,
    PersonOrgFinancialProfile,
} from '@ndvr/customer-api';

export const getPrimaryManagerName = (household: CommandCenterHousehold) => {
    const firstName = household.primaryManagerFirstNamePlain;
    const lastName = household.primaryManagerLastNamePlain;
    return !(firstName && lastName) ? '' : `${firstName} ${lastName}`;
};

export const getHouseholdTypeLabel = (householdType: HouseholdType) =>
    householdType === HouseholdType.PROSPECT
        ? 'Prospect'
        : householdType === HouseholdType.ONBOARDING
          ? 'Onboarding household'
          : 'Household';

export const getHouseholdName = (household?: {
    globalAccountNamePlain?: string | null;
    householdType?: HouseholdType;
}) => {
    return (
        household?.globalAccountNamePlain ||
        `Unnamed ${getHouseholdTypeLabel(household?.householdType ?? HouseholdType.CLIENT)}`
    );
};

export const getPersonByRole = (profiles: PersonOrgFinancialProfile[] | undefined, role: GlobalAccountRoleType) => {
    return profiles?.find((personProfile) =>
        personProfile.profile.globalAccountPersonOrgRoles?.some((link) => link.roleType === role),
    );
};
